import SelectBlueCheckBox from 'assets/Icons/CheckBox/SelectBlueCheckBox';
import SelectRedCheckBox from 'assets/Icons/CheckBox/SelectRedCheckBox';
import React from 'react';
import styled from 'styled-components';
import { BackgroundColor, BorderColor, IconColor, PrimaryColor, TextColor, WarningColor } from 'styles/Global/colorSemantic';
import { Radius } from 'styles/Global/objectStyles';
import { Body3Medium } from 'styles/Global/typography';

interface ConfirmButtonProps {
    checked: boolean;
    setChecked: () => void;
    label: string;
}

export const MixConfirmed = ({ checked, setChecked, label }: ConfirmButtonProps) => {
    return checked ? <Confirmed checked={checked} setChecked={setChecked} label={label} /> : <NotConfirmed checked={checked} setChecked={setChecked} label={label} />;
};
export const NotConfirmed = ({ checked, setChecked, label }: ConfirmButtonProps) => {
    return (
        <NotComfirmedLayout onClick={setChecked}>
            {checked ? <SelectBlueCheckBox /> : <CheckBox />}
            <DescWrapper>
                <Label>{label}</Label>
                <Warning>(필수)</Warning>
            </DescWrapper>
        </NotComfirmedLayout>
    );
};
export const Confirmed = ({ checked, setChecked, label }: ConfirmButtonProps) => {
    return (
        <ComfirmedLayout onClick={setChecked}>
            {checked ? <SelectRedCheckBox /> : <CheckBox />}
            <DescWrapper>
                <Label>{label}</Label>
                <Warning>(필수)</Warning>
            </DescWrapper>
        </ComfirmedLayout>
    );
};

const NotComfirmedLayout = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 60px;
    border-radius: ${Radius.radius_4};
    border: 1px solid ${BorderColor.color_border_normal};
    gap: 10px;

    &:hover {
        background-color: ${BackgroundColor.color_background_light};
    }

    &:active {
        background-color: ${BackgroundColor.color_background_neutral};
    }
`;
const ComfirmedLayout = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 60px;
    border-radius: ${Radius.radius_4};
    background-color: ${BackgroundColor.color_background_warning};
    border: 1px solid ${WarningColor.color_warning_normal_disabled};
    gap: 10px;

    &:hover {
        background-color: ${BackgroundColor.color_background_warning_hover};
    }

    &:active {
        background-color: ${BackgroundColor.color_background_warning_press};
    }
`;

const DescWrapper = styled.div`
    display: flex;
    gap: 4px;
`;

const Label = styled(Body3Medium)`
    color: ${TextColor.color_text_light};
`;

const Warning = styled(Body3Medium)`
    color: ${WarningColor.color_warning_normal};
`;

const CheckBox = styled.div<{ disabled?: boolean }>`
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 1px solid ${IconColor.color_icon_light};
    background-color: ${BackgroundColor.color_background_white};
    &:hover {
        border: 1px solid ${IconColor.color_icon_neutral};
    }
    &:active {
        border: 1px solid ${PrimaryColor.color_primary_normal};
    }
    &:focus {
        border: 1px solid ${PrimaryColor.color_primary_normal};
    }
    ${(props) =>
        props.disabled &&
        `
        border: 1px solid ${BorderColor.color_border_neutral};
        background-color: ${BackgroundColor.color_background_disabled};
    `}
`;
